import { gql } from "lib/apolloClient";

export const downloadTranscriptsMutation = gql`
  mutation downloadTranscripts($input: GenerateTranscriptDownloadUrlInput!) {
    transcript {
      generateTranscriptDownloadUrl(input: $input) {
        filename
        url
        isLongRunningTaskCreated
      }
    }
  }
`;
